import React from 'react';

const Main: React.FC = () => {
  return (
    <main>
      <div className="landing-title">
        <h1 className="site-title">Friendshrimp</h1>
        <p className="subtitle">for friends.</p>
      </div>
    </main>
  );
};

export default Main;
